import React, { useContext } from "react";
import { IconButton, useTheme } from "@mui/material";
import { ArrowCircleLeft, ArrowCircleRight } from "@mui/icons-material";

import FixedAppBar from "components/styled/FixedAppBar";

import { PAGES } from "utils/constants";
import { PageContext } from "utils/PageContext";
import { UserContext } from "utils/UserContext";

import PropTypes from "prop-types";

function PageArrows({ handlePrevPage, handleNextPage, isPageComplete }) {
  const mainTheme = useTheme();

  const { setCurrentStep } = useContext(UserContext);

  const { page } = useContext(PageContext);

  const handleNextStep = () => {
    setCurrentStep((prevCurrentStep) => prevCurrentStep + 1);
  };

  const handlePrevStep = () => {
    setCurrentStep((prevCurrentStep) => prevCurrentStep - 1);
  };

  // const maxSteps = Object.keys(PAGES).length;

  const buttonStyling = {
    minWidth: "4rem",
    maxWidth: "6rem",
    minHeight: "4rem",
    maxHeight: "6rem",
    [mainTheme.breakpoints.down("sm")]: {
      width: "4rem",
      height: "4rem",
    },
  };

  return (
    <FixedAppBar position="fixed" component="footer">
      <IconButton
        size="large"
        onClick={() => {
          handlePrevPage();
          if (page !== PAGES.SEARCH) {
            handlePrevStep();
          }
        }}
        sx={{
          color: "#fff",
        }}
      >
        {mainTheme.direction === "rtl" ? (
          <ArrowCircleRight sx={buttonStyling} />
        ) : (
          <ArrowCircleLeft sx={buttonStyling} />
        )}
      </IconButton>

      <IconButton
        size="large"
        onClick={() => {
          handleNextPage();
          handleNextStep();
        }}
        disabled={!isPageComplete}
        sx={{
          color: isPageComplete
            ? mainTheme.palette.darkBluePrimary.main
            : "#fff",
        }}
      >
        {mainTheme.direction === "rtl" ? (
          <ArrowCircleLeft sx={buttonStyling} />
        ) : (
          <ArrowCircleRight sx={buttonStyling} />
        )}
      </IconButton>
    </FixedAppBar>
  );
}

PageArrows.propTypes = {
  handlePrevPage: PropTypes.func.isRequired,
  handleNextPage: PropTypes.func.isRequired,
  isPageComplete: PropTypes.bool.isRequired,
};

export default PageArrows;
